<template>
  <div class="flex items-center justify-center py-4">
    <div class="feeder">
      <div style="--delay: 0"><i class="fa-solid fa-helmet-safety"></i></div>
      <div style="--delay: 0.25"><i class="fa-solid fa-industry"></i></div>
      <div style="--delay: 0.5"><i class="fa-solid fa-gear"></i></div>
      <div style="--delay: 0.75"><i class="fa-solid fa-user-shield"></i></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@keyframes fed {
  0% {
    opacity: 0;
    transform: translateX(-500%);
  }
  30%,
  70% {
    opacity: 1;
    transform: translateX(0);
  }
  50% {
    transform: translateX(0) scale(2.5);
  }
  40%,
  60% {
    transform: translateX(0) scale(1.5);
  }
  100% {
    opacity: 0;
    transform: translateX(500%);
  }
}

@keyframes feed {
  0% {
    opacity: 0;
    transform: translateX(-500%);
  }
  40% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(500%);
  }
}

.feeder {
  position: relative;
  width: 2rem;
  height: 2rem;

  div {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: #4b5563; // Tailwind gray-700

    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-fill-mode: backwards;
    animation-delay: calc(var(--delay) * 1s);
    animation-name: fed;

    &:nth-child(2),
    &:nth-child(3) {
      animation-name: feed;
    }
  }
}
</style>
